import type { FC } from 'react';
import React from 'react';
import { Img } from '@alfa-bank/site-img';
import { BlockHolder } from '@alfa-bank/site-block-holder';

import { Circle } from '../circle/circle';
import { calculateProgress } from '../circle/helpers';

import type { TCircleProgress } from './models';
export const CircleProgress: FC<TCircleProgress> = ({
    alt,
    className,
    config,
    dynamic,
    index,
    progress,
    src,
    styler,
}) => {
    const { centerX, centerY, fullAngle, height, numberCoordinates, radius, width } = config;
    const progressPath = calculateProgress(progress, centerX, centerY, radius, fullAngle);

    return dynamic ? (
        <BlockHolder
            className={className}
            height={`${height}px`}
            styler={styler}
            width={`${width}px`}
        >
            <Circle
                centerX={centerX}
                centerY={centerY}
                height={height}
                numberPath={numberCoordinates[index]}
                progressPath={progressPath}
                radius={radius}
                width={width}
            />
        </BlockHolder>
    ) : (
        <Img
            alt={alt || `get-card-step-${index}`}
            className={className}
            height={`${height}px`}
            src={src}
            styler={styler}
            width={`${width}px`}
        />
    );
};
